// removed by extract-text-webpack-plugin
module.exports = {"task":"Task__task___3kK-X","check":"Task__check___2gn3b","content":"Task__content___1TIvW","connected":"Task__connected___oiA7x","date":"Task__date___1REHe","notes":"Task__notes___qx6fS","priority":"Task__priority___2RdCA","buttonArea":"Task__buttonArea___3QX1g","chatIcon":"Task__chatIcon___11zfs","fileIcon":"Task__fileIcon___3-WlY","completed":"Task__completed___25Gut"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Task/Task.scss
// module id = 1199
// module chunks = 1